import {
    Component,
    ElementRef,
    EventEmitter,
    Input,
    OnChanges,
    OnInit,
    Output,
    SimpleChanges,
    ViewChild, ViewChildren,
} from '@angular/core';
import { UploadFileComponent } from '@app/shared/components/upload-file/upload-file.component';
import { FileService } from '@services/lm/file.service';
import 'tinymce/icons/default/icons.min';

@Component({
    selector: 'app-tinymce-editor',
    templateUrl: './tinymce-editor.component.html',
    styleUrls: ['./tinymce-editor.component.less'],
})
export class TinymceEditorComponent implements OnInit, OnChanges {
    @ViewChild('uploadImage') uploadImage!: UploadFileComponent;
    @Input() uploadPath = '';
    @Input() editorContent = '';
    @Input() editorId = 'editor';
    @Output() editorContentChange = new EventEmitter();
    changeTimer: number | null = null;

    value = '';
    editor!: any;
    init = false;
    accept = 'image/png, image/x-png, image/jpeg, image/jpg, image/pjpeg';
    editorConfig = {
        base_url: '/tinymce',
        min_height: 100,
        max_height: 200,
        menubar: false,
        plugins: ['autoresize', 'image', 'paste'],
        content_style: 'body {margin: 8px} p {margin: 0} img {max-height:150px;vertical-align:top}',
        style_formats_merge: true,
        style_formats_autohide: true,
        toolbar: 'custom_image',
        statusbar: false,
        branding: false,
        paste_data_images: true,
        images_upload_handler: (blobInfo: any, success: any) => {
            this.handlerAddImg(blobInfo.blob(), success);
        },
        setup: (editor: any) => {
            this.init = true;
            this.editor = editor;
            editor.ui.registry.addButton('custom_image', {
                text: '',
                icon: 'image',
                onAction: () => {
                    this.uploadImage?.uploadClick();
                },
            });
            console.log('setUp', editor, this.editor);
        },
    };

    constructor(private fileService: FileService) {
    }

    ngOnInit(): void {
    }

    upload(file: File): void {
        this.handlerAddImg(file);
    }

    ngOnChanges(changes: SimpleChanges): void {
        const { editorContent } = changes;
        if (editorContent) {
            if (this.value === editorContent.currentValue) {
                return;
            }
            setTimeout(() => {
                this.value = editorContent.currentValue;
            }, 200);
        }
    }

    initEditor(): void {
    }

    changeValue(): void {
        if (!this.init) {
            return;
        }
        if (this.changeTimer) {
            clearTimeout(this.changeTimer);
        }
        this.changeTimer = setTimeout(() => {
            this.editorContentChange.emit(this.value);
        }, 200);
    }

    async handlerAddImg(file: File, success?: any): Promise<void> {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('path', this.uploadPath);
        const res = await this.fileService.uploadFile(formData);
        const imagePath = this.fileService.getPath(res.path);
        if (success) {
            success(imagePath);
        } else {
            this.editor.insertContent(`<img src="${imagePath}" />`);
        }
    }
}
